<div class="html-content" [formGroup]="form">
  <div class="html-content_section">
    <label>Paste HTML Code Here</label>
    <textarea class="html-content_block" [formControlName]="controlName"></textarea>
  </div>
  <div class="html-content_section preview-content">
    <label>Preview</label>
    <div class="html-content_block " [innerHTML]="sanitizedContent"></div>
  </div>
</div>
